// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.scss'
import '@/assets/iconfont/iconfont.css'
import App from './App'
import router from './router'
import store from './store'
import echarts from 'echarts'
import 'echarts/theme/macarons'
import {productionTip} from './global/global-bak'
import globleconfig from './global/globlaconfig'
import { Loading } from 'element-ui';

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

Vue.use(ElementUi);

Vue.config.productionTip = {productionTip}
Vue.prototype.$echarts = echarts;
Vue.prototype.GCONFIG=globleconfig;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})


// WEBPACK FOOTER //
// ./src/main.js